import classNames from 'classnames';

import styles from './_index.module.scss';

export interface CardProps extends React.HTMLAttributes<HTMLElement> {
  elevation?: 0 | 1 | 2 | 3;
  // eslint-disable-next-line perfectionist/sort-union-types
  padding?: 'small' | 'medium' | 'large' | 'x-large';
  status?: 'error' | 'info' | 'success' | 'warn';
  statusColor?: string;
}

const Card = <T extends React.ElementType = 'div'>({
  as,
  className,
  elevation = 0,
  padding = 'medium',
  status,
  statusColor,
  ...props
}: CardProps & PolymorphicProps<T>) => {
  const Component = as || 'div';
  return (
    <Component
      className={classNames(
        styles['card'],
        styles[`is-elevation-${elevation}`],
        styles[`is-padding-${padding}`],
        { [styles['is-status-color']]: statusColor, [styles[`is-status-${status}`]]: status },
        className
      )}
      style={statusColor ? { '--status-color': statusColor } : {}}
      {...props}
    />
  );
};

export default Card;
